import type Chair from "./chair";

export enum VULNERABILITY {
    NONE = 1,
    NS = 2,
    EW = 3,
    BOTH = 4,
}

export default class Vulnerability {
    value = VULNERABILITY.NONE;

    constructor(vulnerability?: VULNERABILITY) {
        if (vulnerability)
            this.value = vulnerability;
    }

    static fromInt(i: number) {
        return new Vulnerability().setValue(i);
    }

    isVulnerable(chair: Chair) {
        if (chair.isNS()) {
            return (this.value === VULNERABILITY.BOTH || this.value === VULNERABILITY.NS);
        } else if (chair.isEW()) {
            return (this.value === VULNERABILITY.BOTH || this.value === VULNERABILITY.EW);
        }
        return false;
    }

    isNone() { return this.value === VULNERABILITY.NONE; }
    isNS() { return this.value === VULNERABILITY.NS; }
    isEW() { return this.value === VULNERABILITY.EW; }
    isAll() { return this.value === VULNERABILITY.BOTH; }

    set(vulnerability: Vulnerability) { this.value = vulnerability.value; return this; }
    setValue(value: VULNERABILITY) { this.value = value; return this; }
    setNone() { this.value = VULNERABILITY.NONE; return this; }
    setNS() { this.value = VULNERABILITY.NS; return this; }
    setEW() { this.value = VULNERABILITY.EW; return this; }
    setAll() { this.value = VULNERABILITY.BOTH; return this; }

    fromString(s: string) {
        if (s === 'None') this.value = VULNERABILITY.NONE;
        else if (s === 'NS') this.value = VULNERABILITY.NS;
        else if (s === 'EW') this.value = VULNERABILITY.EW;
        else if (s === 'All') this.value = VULNERABILITY.BOTH;

        return this;
    }

    toString() {
        switch (this.value) {
            case VULNERABILITY.NONE: return "None";
            case VULNERABILITY.NS: return "NS";
            case VULNERABILITY.EW: return "EW";
            case VULNERABILITY.BOTH: return "All";
            default: return "#ERROR";
        }
    }
}